import React, { Fragment } from 'react';
import { Row, Col, Button, Select, Icon, Input } from 'antd';

const { Option } = Select;

const filterStyles = `
.pof-panel { border:1px solid #e6f0ff; border-radius:10px; margin:10px 0; background:#fff; box-shadow:0 2px 8px rgba(24,144,255,0.05); overflow:hidden; }
.pof-header { padding:10px 16px; background:#f0f7ff; border-bottom:1px solid #e6f0ff; display:flex; align-items:center; gap:8px; }
.pof-header-label { font-size:11px; font-weight:700; color:#1890ff; letter-spacing:1px; text-transform:uppercase; }
.pof-body { padding:14px 16px 16px; }
.pof-label { font-size:10px; font-weight:700; color:#8c8c8c; letter-spacing:.8px; text-transform:uppercase; margin-bottom:4px; display:block; }

.pof-panel .ant-input { border-radius:7px!important; border:1.5px solid #d6e8ff!important; font-size:12px!important; height:32px!important; }
.pof-panel .ant-input:focus,.pof-panel .ant-input:hover { border-color:#1890ff!important; box-shadow:0 0 0 2px rgba(24,144,255,.1)!important; }
.pof-panel .ant-select-selection { border-radius:7px!important; border:1.5px solid #d6e8ff!important; font-size:12px!important; height:32px!important; }
.pof-panel .ant-select-selection:hover { border-color:#1890ff!important; }
.pof-panel .ant-select-selection__rendered { line-height:30px!important; }

.pof-btn-filter { border-radius:7px!important; height:32px!important; font-size:11px!important; font-weight:700!important; background:linear-gradient(135deg,#1890ff 0%,#096dd9 100%)!important; border:none!important; box-shadow:0 3px 10px rgba(24,144,255,.3)!important; width:100%!important; }
.pof-btn-filter:hover { transform:translateY(-1px)!important; box-shadow:0 5px 16px rgba(24,144,255,.4)!important; }
.pof-btn-reset { border-radius:7px!important; height:32px!important; font-size:11px!important; font-weight:700!important; border:1.5px solid #d6e8ff!important; background:#f0f7ff!important; color:#1890ff!important; width:100%!important; }
.pof-btn-reset:hover { background:#e6f0ff!important; border-color:#1890ff!important; }
`;

const yearOpt = Array.from({ length: 16 }, (_, i) => 2015 + i);

const PolistFilter = ({ customers = [], filter, setFilter, onFilter, onResetFilter }) => {
  const customerOpt = customers
    .filter(c => c.isApproved === 'APPROVED')
    .map(c => <Option key={c.id} value={c.id}>{c.bi_name}</Option>);

  return (
    <Fragment>
      <style>{filterStyles}</style>
      <div className="pof-panel">

        <div className="pof-header">
          <Icon type="filter" style={{ fontSize: 12, color: '#1890ff' }} />
          <span className="pof-header-label">Advance Filter</span>
        </div>

        <div className="pof-body">
          {/* Row 1 */}
          <Row gutter={[16, 12]}>
            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">Search</span>
              <Input
                prefix={<Icon type="search" style={{ color: '#bfbfbf', fontSize: 12 }} />}
                value={filter.search}
                onChange={e => setFilter({ ...filter, search: e.target.value })}
                onPressEnter={() => onFilter()}
                placeholder="Input purchase order no."
                allowClear
              />
            </Col>

            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">Customer</span>
              <Select
                onChange={val => setFilter({ ...filter, customer: val })}
                value={filter.customer}
                style={{ width: '100%' }}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                loading={customers.length < 1}
                showSearch
                placeholder="All customers"
              >
                <Option value={null}>All</Option>
                {customerOpt}
              </Select>
            </Col>

            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">Sort</span>
              <Select
                value={filter.sort}
                onChange={sort => setFilter({ ...filter, sort })}
                style={{ width: '100%' }}
              >
                <Option value="latest"><Icon type="sort-descending" style={{ marginRight: 6 }} />Latest record</Option>
                <Option value="oldest"><Icon type="sort-ascending"  style={{ marginRight: 6 }} />Oldest record</Option>
                <Option value="date-asc"><Icon type="sort-ascending"  style={{ marginRight: 6 }} />Date ascending</Option>
                <Option value="date-desc"><Icon type="sort-descending" style={{ marginRight: 6 }} />Date descending</Option>
              </Select>
            </Col>

            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">Status</span>
              <Select
                value={filter.status}
                onChange={status => setFilter({ ...filter, status })}
                style={{ width: '100%' }}
              >
                <Option value={null}>All</Option>
                <Option value="OPEN"><span style={{ color: '#389e0d', fontWeight: 700 }}>● OPEN</span></Option>
                <Option value="SERVED"><span style={{ color: '#08979c', fontWeight: 700 }}>● SERVED</span></Option>
              </Select>
            </Col>
          </Row>

          {/* Row 2 */}
          <Row gutter={[16, 12]} style={{ marginTop: 8 }}>
            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">Month</span>
              <Select
                onChange={val => setFilter({ ...filter, month: val })}
                value={filter.month}
                style={{ width: '100%' }}
              >
                <Option value={null}>All</Option>
                {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m, i) => (
                  <Option key={i + 1} value={i + 1}>{m}</Option>
                ))}
              </Select>
            </Col>

            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">Year</span>
              <Select
                value={filter.year}
                style={{ width: '100%' }}
                onChange={val => setFilter({ ...filter, year: val })}
              >
                <Option value={null}>All</Option>
                {yearOpt.map(val => <Option key={val} value={val}>{val}</Option>)}
              </Select>
            </Col>

            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">&nbsp;</span>
              <Button className="pof-btn-filter" onClick={() => onFilter()} type="primary" icon="filter" block>
                Filter
              </Button>
            </Col>

            <Col lg={{ span: 6 }} xs={24} sm={12}>
              <span className="pof-label">&nbsp;</span>
              <Button className="pof-btn-reset" onClick={onResetFilter} icon="undo" block>
                Reset
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </Fragment>
  );
};

export default PolistFilter;